<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Søk {{ fieldTitle }}</ion-title>
  </ion-toolbar>
  
  <!-- Search bar -->
  <ion-toolbar>
    <ion-searchbar
      [formControl]="searchControl"
      placeholder="Søk..."
      debounce="300"
      animated
      show-clear-button="focus">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item
      *ngFor="let item of filteredData | async"
      button
      (click)="selectItem(item)"
      detail="false">
      <ion-label>
        <h2><strong>{{ getDisplayName(item) }}</strong></h2>
        <p *ngIf="getSecondaryInfo(item)">{{ getSecondaryInfo(item) }}</p>
        <p *ngIf="getTertiaryInfo(item)" class="tertiary-info">{{ getTertiaryInfo(item) }}</p>
      </ion-label>
    </ion-item>
    
    <!-- Empty state - show prompt if using live search -->
    <ion-item *ngIf="(filteredData | async)?.length === 0">
      <ion-label class="ion-text-center">
        <p *ngIf="searchFunction && searchControl.value && searchControl.value.length < 2">
          Skriv minst 2 tegn for å søke
        </p>
        <p *ngIf="!searchFunction || !searchControl.value || searchControl.value.length >= 2">
          Ingen resultater funnet
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
